<template>
  <div class="introductoryArticles">
    <div class="introductoryArticles-top">
      <van-image class="introductoryArticles-img" :src="img" />
      <div style="padding: 0 7px">
        <van-dropdown-menu>
          <van-dropdown-item
            v-model="value1"
            @change="onChange"
            :options="keyWord"
          />
        </van-dropdown-menu>
      </div>
    </div>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div class="introductoryArticles-bottom">
        <div
          class="introductoryArticles-bottom-box"
          v-for="item in CangPinList"
          :key="item.bianhao"
        >
          <div
            class="introductoryArticles-bottom-boxs vant-image-box"
            v-touch:tap="skip(item)"
          >
            <!-- <van-image width="100%" height="100%" radius="10" v-bind:src="item.image" /> -->
            <van-image
              class="itme-image"
              fit="cover"
              lazy-load
              :src="item.pics[0]"
              v-if="item.pics"
            />

            <div class="img-title">{{ item.mingchen }}</div>
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>
<script>
import md5 from "js-md5";
import { Swipe, SwipeItem, DropdownMenu, DropdownItem, List } from "vant";
import http from "@js/http-ww.js";
import axios from "axios";
import { getAllTabulateUrl } from "@culturalRelicsUrl";
export default {
  data() {
    return {
      current: 0,
      typeID: "811a8f3a-96b4-483e-baa3-d44d59409c90",
      img: require("../../lib/image/IntroductoryArticles/1.png"),
      CangPinList: [],
      client_id: "bb89496b4c97801a7367420c14b2208f",
      secret: "asdfdfdfasdfwerfgh4545d",
      timestamp: new Date().getTime(),
      endPageNum: 0,
      // 藏品分类
      keyWord: [
        { text: "全部", value: 0 },
        { text: "陶器", value: 1 },
        { text: "铜器", value: 2 },
        { text: "玉石器、宝石", value: 3 },
        { text: "瓷器", value: 4 },
        { text: "金银器", value: 5 },
        { text: "铁器、其他金属器", value: 6 },
        { text: "漆器", value: 7 },
        { text: "雕塑、造像", value: 8 },
        { text: "石器、石刻、砖瓦", value: 9 },
        { text: "书法、绘画", value: 10 },
        { text: "文具", value: 11 },
        { text: "甲骨", value: 12 },
        { text: "玺印符牌", value: 13 },
        { text: "钱币", value: 14 },
        { text: "牙骨角器", value: 15 },
        { text: "竹木雕", value: 16 },
        { text: "家具", value: 17 },
        { text: "珐琅器", value: 18 },
        { text: "织绣", value: 19 },
        { text: "古籍图书", value: 20 },
        { text: "碑帖拓本", value: 21 },
        { text: "武器", value: 22 },
        { text: "邮品", value: 23 },
        { text: "文件、宣传品", value: 24 },
        { text: "档案文书", value: 25 },
        { text: "名人遗物", value: 26 },
        { text: "玻璃器", value: 27 },
        { text: "乐器、法器", value: 28 },
        { text: "皮革", value: 29 },
        { text: "音像制品", value: 30 },
        { text: "票据", value: 31 },
        { text: "交通、运输工具", value: 32 },
        { text: "度量衡器", value: 33 },
        { text: "标本、化石", value: 34 },
        { text: "其他", value: 35 },
      ],
      value1: 0,
      // 照片前缀
      picsPrefix: "http://www.hainanmuseum.org/cms/1/image/public/wenwu/",
      loading: false,
      finished: false,
      List: [],
    };
  },
  mounted() {
    //  默认显示全部
    // this.getAllTabulateList();
  },
  computed: {
    $sign() {
      return md5(this.$params + "asdfdfdfasdfwerfgh4545d");
    },
    $params() {
      return `client_id=${this.client_id}&timestamp=${this.timestamp}`;
    },
  },
  methods: {
    onChange(value) {
      let keyword = this.keyWord[value].text;
      this.getAllTabulateList(keyword);
    },
    //跳转详情页
    skip(item) {
      return () => {
        this.$router
          .push({ path: "listdetailed", query: { item } })
          .catch((err) => {
            err;
          });
      };
    },
    // 触底加载
    onLoad() {
      this.loading = true;
      this.endPageNum += 15;
      this.getAllTabulateList();
    },
    //获取文物列表
    async getAllTabulateList(keyword = "") {
      await axios
        .get(getAllTabulateUrl, {
          params: {
            client_id: this.client_id,
            timestamp: this.timestamp,
            sign: this.$sign,
            leibie: keyword,
            pagesize: this.endPageNum,
          },
        })
        .then(({ data: { data, count } }) => {
          this.CangPinList = data;
          //   循环重写图片地址
          this.CangPinList.map((t) => {
            if (t.pics) {
              t.pics = t.pics.map((item) => `${this.picsPrefix}${item}.png`);
            }
          });

          if (count == 0) {
            this.finished = true;
            this.$toast("无数据");
          } else if (this.CangPinList.length >= count) {
            this.finished = true;
          }
          this.loading = false;
        });
    },
  },
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [List.name]: List,
  },
};
</script>

<style lang="less" scoped>
.introductoryArticles {
  background-color: #f3f4fe !important;
  .introductoryArticles-top {
    .my-swipe {
      position: relative;
      top: -26px;
      height: 81px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 1px 8px 0px rgba(212, 206, 218, 0.5);
      border-radius: 10px;
      .van-swipe-item {
        height: 81px;
        .topCut-box {
          padding: 15px;
          overflow: auto;
          zoom: 1;
          .topCut-box-boxs {
            width: 20%;
            float: left;
            .topCut-box-boxs-text {
              color: #8e969e;
              font-size: 14px;
              text-align: center;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .topCut-box-boxs-img {
              height: 26px;
              width: 100%;
              text-align: center;
            }
            .boxs-img {
              width: 24px;
              height: 21px;
            }
          }
        }
      }
    }
    .introductoryArticles-img {
      height: 185px;
      width: 100%;
    }
  }
  //下面
  .introductoryArticles-bottom {
    overflow: auto;
    zoom: 1;
    padding: 0 3px 40px 3px;
    .introductoryArticles-bottom-box {
      width: 50%;
      float: left;
      .introductoryArticles-bottom-boxs {
        margin: 0 4px;
        margin-top: 18px;
        height: 128px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 1px 2px 0px rgba(200, 200, 200, 0.5);
        border-radius: 10px;
        position: relative;
        overflow: hidden;
        .itme-image {
          width: 100%;
          height: 100%;
        }
      }
      .img-title {
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 34px;
        line-height: 34px;
        // background:rgba(255,255,255,0.50);
        // color:rgba(68,72,78,1);
        background: rgba(128, 128, 128, 0.39);
        color: #ffffff;
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
        text-align: center;
        font-weight: 500;
        font-size: 12px;
      }
    }
  }
}
</style>